// extracted by mini-css-extract-plugin
module.exports = {"header":"Nav_header__SU0vH","logo":"Nav_logo__71uWK","active":"Nav_active__Ugv-c","badge":"Nav_badge__2cGq9"};